export function initDismissBars(): void {
  document
    .querySelectorAll<HTMLElement>("[data-dismiss-key]")
    .forEach((bar) => {
      const storageKey = bar.dataset.dismissKey;
      if (!storageKey) return;

      const closeBtn = bar.querySelector<HTMLButtonElement>(
        ".announcement-bar__close",
      );
      if (!closeBtn) return;

      closeBtn.addEventListener("click", (e) => {
        e.preventDefault();
        bar.style.maxHeight = String(bar.offsetHeight) + "px";
        requestAnimationFrame(() => {
          bar.classList.add("announcement-bar--dismissing");
          bar.addEventListener(
            "transitionend",
            () => {
              bar.hidden = true;
            },
            { once: true },
          );
          setTimeout(() => {
            bar.hidden = true;
          }, 300);
        });
        sessionStorage.setItem(storageKey, "1");
      });
    });
}
